module.exports = {"320682001":"如城街道","320682103":"东陈镇","320682104":"丁堰镇","320682105":"白蒲镇","320682107":"下原镇","320682108":"九华镇","320682110":"石庄镇","320682111":"长江镇","320682112":"吴窑镇","320682113":"江安镇","320682116":"搬经镇","320682117":"磨头镇","320682400":"如皋市经济开发区","320682401":"如皋高新技术产业开发区","320682402":"南通市粮棉原种场","320682403":"如皋市蚕种场","320682404":"如皋市良种场","320682406":"如皋市种猪场","320682407":"如皋市农科所","320682408":"如皋市江滨医院","320682409":"如皋市中心沙水产养殖场","320682410":"如皋市九华水产养殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320682.json
// module id = 882
// module chunks = 0